export default "__VITE_ASSET__CyDXvThl__"